import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { withPage } from "../../Page";
import Selectors from "../../Selectors";
import ActionCreator from "../../ActionCreator";
import * as Widget from "../../Components/Widget";
import StorePromiseSection from "../../Components/StorePromiseSection";
import StoreCategorySection from "../../Components/StoreCategorySection";
import JoinUsBubble from "../../Components/JoinUsBubble";
import ChattyButton from "../../../chatty/Components/ChattyButton";

const data = [
  { display: "咖啡比賽常勝軍", img: "icon01" },
  { display: "個性風格空間", img: "icon02" },
  { display: "人氣票選店家", img: "icon03" },
  { display: "咖啡玩家首選", img: "icon04" }
];

class StoreListingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSpinner: false
    };
  }

  render() {
    let { store, navActions } = this.props;
    let { showSpinner } = this.state;

    let storeArray = store.results;
    if (showSpinner) {
      return <Widget.Spinner />;
    }

    return (
      <Wrapper>
        <Widget.MaxWidth width={1140} extraCss="margin-bottom: 82px;">
          <StorePromiseSection css="margin-bottom: 100px;" />
          {data.map((d, i) => (
            <StoreCategorySection key={i} data={d} css="margin-bottom: 95px;" />
          ))}
          <JoinUsBubble />
        </Widget.MaxWidth>
        {/* <ChattyButton /> */}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  margin-top: 75px;
  width: 100%;
`;

export default withPage(
  connect(
    (state, ownProps) => ({
      store: Selectors.getStoreList(state)
    }),
    ActionCreator
  )(StoreListingPage)
);
